import { Component, Input } from '@angular/core';
import { CompanyDetails } from '../../models/company-details';

@Component({
  selector: 'app-record-quota',
  standalone: true,
  imports: [],
  templateUrl: './record-quota.component.html',
  styleUrl: './record-quota.component.scss',
})
export class RecordQuotaComponent {
  @Input() recordDetails!: CompanyDetails;
  @Input() isAssignButtonHovered = false;

  isQuotaExceeded(): boolean {
    return !!(
      this.recordDetails?.lead_quota &&
      this.recordDetails.lead_quota.lead_count >=
        this.recordDetails.lead_quota.quota
    );
  }
}
